{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Stack Maps ID",
      "folder": "Disposition Header",
      "tnum": true,
    },
  },
  "disposition_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Disposition No.",
      "folder": "Disposition Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Disposition Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "company": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Company",
      "folder": "Disposition Header",
      "width": 250,
      "isShownByDefault": true,
    },
  },
  "disposition_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
    "gpt": {
      "hint": "A 3-letter code, e.g. 'MSL' for 'Mineral Surface Lease'",
    },
  },
  "disposition_type_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Type",
      "folder": "Disposition Header",
      "width": 200,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "The full name of the disposition type, e.g. 'Mineral Surface Lease'",
    },
  },
  "status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Status",
      "folder": "Disposition Header",
      "width": 200,
      "isShownByDefault": true,
    },
  },
  "application_number": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Application No.",
      "folder": "Disposition Header",
      "isShownByDefault": true,
    },
  },
  "legacy_ogc_number": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Legacy OGC No.",
      "folder": "Disposition Header",
      "isShownByDefault": true,
    },
  },
  "road_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Road No.",
      "folder": "Disposition Header",
      "width": 120,
      "isShownByDefault": true,
    },
  },
  "plan_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Plan No.",
      "folder": "Disposition Header",
      "tnum": true,
    },
  },
  "document_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Document Type",
      "folder": "Disposition Header",
    },
  },
  "area_acres": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "acre",
    },
    "ui": {
      "label": "Area in Acres",
      "folder": "Details",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "area_hectares": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha",
    },
    "ui": {
      "label": "Area in Hectares",
      "folder": "Details",
    },
  },
  "client_code": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Client Code",
      "folder": "Details",
    },
  },
  "client_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Client Count",
      "folder": "Details",
    },
  },
  "dimensions": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Dimensions",
      "folder": "Details",
    },
  },
  "discrepancy_flag": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Discrepancy",
      "folder": "Details",
    },
  },
  "first_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "First Name",
      "folder": "Details",
    },
  },
  "last_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Last Name",
      "folder": "Details",
    },
  },
  "general_comments": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Comments",
      "folder": "Details",
    },
  },
  "near_water_flag": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Near Water",
      "folder": "Details",
    },
  },
  "purpose_code": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Purpose Code",
      "folder": "Details",
    },
  },
  "purpose_additional_info": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Purpose Additional Info",
      "folder": "Details",
    },
  },
  "restriction_code": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Restriction Code",
      "folder": "Details",
    },
  },
  "amendment_loa_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Amendment LOA Date",
      "folder": "Dates",
    },
  },
  "amendment_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Amendment Date",
      "folder": "Dates",
    },
  },
  "application_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Application Date",
      "folder": "Dates",
    },
  },
  "cancellation_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Cancellation Date",
      "folder": "Dates",
    },
  },
  "edit_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Edit Date",
      "folder": "Dates",
    },
  },
  "effective_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Effective Date",
      "folder": "Dates",
    },
  },
  "expiry_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Expiry Date",
      "folder": "Dates",
    },
  },
  "loa_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "LOA Date",
      "folder": "Dates",
    },
  },
  "process_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Process Date",
      "folder": "Dates",
    },
  },
  "reinstatement_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Reinstatement Date",
      "folder": "Dates",
    },
  },
  "renewal_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Renewal Date",
      "folder": "Dates",
    },
  },
  "version_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Version Date",
      "folder": "Dates",
    },
  },
  "notification_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Notification Date",
      "folder": "Dates",
    },
  },
  "site_entry_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Site Entry Date",
      "folder": "Dates",
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
